module.exports = __webpack_public_path__ + "img/04-competition-pricing.8429f325.jpg";